/**
 * parcoursStructure.js
 *
 * Fallback minimal utilisé uniquement si Firestore est indisponible.
 * La vraie configuration du parcours est dans Firestore (parcoursConfig/main).
 */

export const PARCOURS_CHAPITRES = {
  1: {
    name: 'Chapitre 1 — Les Fondations',
    type: 'linear',
    steps: []
  }
};

export const MARCEL_MESSAGES = [];

export const TOTAL_CHAPITRES = 1;

export function getChapitreConfig(chapitreNumber) {
  return PARCOURS_CHAPITRES[chapitreNumber] || null;
}

export function getChapitreSteps(chapitreNumber) {
  const chapitre = PARCOURS_CHAPITRES[chapitreNumber];
  if (!chapitre || chapitre.type !== 'linear') return [];
  return chapitre.steps;
}

export function isAlternatingChapitre(chapitreNumber) {
  return false;
}
